import { render, staticRenderFns } from "./sharedVenueList.vue?vue&type=template&id=1371395f&scoped=true&"
import script from "./sharedVenueList.vue?vue&type=script&lang=js&"
export * from "./sharedVenueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371395f",
  null
  
)

export default component.exports